<template>
	<div class="scene-wrapper">
		<Video :src="video.url" @ended="advance" :muted="$store.state.sound.muted" />
		<Button class="travel-btn" :action="advance">Continue</Button>
	</div>
</template>

<script>
import Button from '@/components/base/Button';
import Video from '@/components/base/Video';

export default {
	name: 'Travel',
	components: {
		Button,
		Video,
	},
	computed: {
		video() {
			const video = this.$store.state.game.chapters.active.travel_video;
			return { ...video, ...this.$store.getters["global/assets/get"](video.id) };
		},
	},
	methods: {
		advance() {
			this.$router.push("/game/travel/complete");
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.travel-btn {
		position: fixed;
		top: 15px;
		right: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/Travel.vue